// extracted by mini-css-extract-plugin
export default {"wrapper":"SchoolPasswordInput_wrapper__bjE06","toggle":"SchoolPasswordInput_toggle__zoclK"};